import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';;
import { useDispatch, useSelector } from 'react-redux';
import { Button, IconButton, Modal, TextField } from '@mui/material';
import { Erroralert, Successalert } from '../../components/popups';
import { Clear } from '@mui/icons-material';



export default function Newsletter({ onsuccesslogin, ondismiss }) {
    const dispatch = useDispatch();
    const webSettings = useSelector((state) => state.webSettings.data);
    const fullName = webSettings.FULL_NAME;

    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');


    return (
        <Modal
            open={true}
            onClose={() => ondismiss()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Container component="main" maxWidth="md" disableGutters style={{ backgroundColor: "white", marginTop: 20 }}>
                <CssBaseline />
                {error?.length > 0 && <Erroralert onClose={() => seterror()} message={error} />}
                {success?.length > 0 && <Successalert onClose={() => setsuccess()} message={success} />}
                <div className='wrapnews'>
                    <img src={require("./../../assets/common/lady.jpg")} />
                    <div className='rightdiv'>
                        <IconButton sx={{ position: "absolute", right: 2 }} onClick={() => ondismiss()}>
                            <Clear />
                        </IconButton>
                        <p align="middle" className='signupdiv'>
                            <div className='signuptitle'>Sign up for our<br /> Newsletter</div>
                            <div className='befirsttext'>Be the first to learn about our latest<br /> trends and get exclusive offers</div>
                            <TextField margin="normal" required sx={{ width: "70%" }}
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                autoFocus
                            /><br /><br />
                            <Button sx={{ width: "40%", pb: 2, pt: 2 }} variant='contained'>Subscribe</Button>
                        </p>
                    </div>
                </div>
            </Container>
        </Modal>

    );
}